// This file exports all of the other interfaces.
export * from "./interfaces/values";
export * from "./services/localization.service";

export * from "./localization.module";
